import React from "react";
import { DATA_EXIT_CONTAINER } from "../../constants";

export const ExitWrapper = ({ children }: { children: React.ReactNode }) => {
	return React.cloneElement(children as React.ReactElement<any>, {
		[DATA_EXIT_CONTAINER]: true,
	});
};
